(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hg-community"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('hg-kol-video')) {
  customElements.define('hg-kol-video', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      const video = this.querySelector('video');
      const button = this.querySelector('.hg-kol-play');
      if (!video || !button) return;
      this.initialized = true;
      this.setAttribute('data-ready', '');
      button.addEventListener('click', () => {
        this.setAttribute('data-started', '');
        video.focus();
        video.play().catch(() => { /* Keep native playback controls available for retry. */ });
      });
      video.addEventListener('play', () => {
        this.setAttribute('data-started', '');
        document.querySelectorAll('hg-kol-video video').forEach(other => {
          if (other !== video) other.pause();
        });
      });
      video.addEventListener('ended', () => {
        const focused = document.activeElement === video;
        this.removeAttribute('data-started');
        if (focused) button.focus();
      });
    }
    disconnectedCallback() {
      const video = this.querySelector('video');
      if (video) video.pause();
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-features"] && !Shopify.designMode) return;
  try {
    

if (!customElements.get('hg-feature-card')) {

  customElements.define(
    'hg-feature-card',

    class extends HTMLElement {

      connectedCallback() {

        if (this.initialized) return;

        this.initialized = true;

        const button =
          this.querySelector('.hg-feature-toggle');


        const update = () => {

          const expanded =
            Boolean(
              this.hovered ||
              this.open ||
              this.selected
            );

          this.toggleAttribute(
            'data-revealed',
            expanded
          );

          if (button) {
            button.setAttribute(
              'aria-expanded',
              String(expanded)
            );
          }

        };


        this.addEventListener(
          'pointerenter',
          event => {

            if (event.pointerType === 'mouse') {

              this.hovered = true;

              update();

            }

          }
        );


        this.addEventListener(
          'pointerleave',
          () => {

            this.hovered = false;

            update();

          }
        );


        if (button) {

          button.addEventListener(
            'click',
            event => {

              if (
                this.hovered &&
                event.detail > 0
              ) {
                return;
              }

              this.open = !this.open;

              update();

            }
          );

        }


        this.addEventListener(
          'focusout',
          event => {

            if (
              !this.contains(
                event.relatedTarget
              )
            ) {

              this.open = false;

              update();

            }

          }
        );


        this.addEventListener(
          'keydown',
          event => {

            if (event.key === 'Escape') {

              this.open = false;
              this.hovered = false;

              update();

            }

          }
        );


        this.addEventListener(
          'shopify:block:select',
          () => {

            this.selected = true;

            update();

          }
        );


        this.addEventListener(
          'shopify:block:deselect',
          () => {

            this.selected = false;

            update();

          }
        );

      }

    }
  );

}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hg-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', event => {const a=event.target.closest('.hg-mobile-menu a');if(a)a.closest('details').open=false;});
document.addEventListener('keydown', event => {if(event.key==='Escape')document.querySelectorAll('.hg-mobile-menu[open]').forEach(el=>{el.open=false;el.querySelector('summary').focus();});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
